import { UseFormReturn } from 'react-hook-form';
import { SurveyFormData } from '@/utils/validation';

interface ConsentSectionProps {
  form: UseFormReturn<SurveyFormData>;
}

const ConsentSection = ({ form }: ConsentSectionProps) => {
  const {
    register,
    formState: { errors },
  } = form;

  return (
    <section aria-labelledby="section-d-heading" className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm">
      <div className="flex items-center mb-6">
        <div className="flex-shrink-0 w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center mr-3">
          <svg className="w-6 h-6 text-primary-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
        </div>
        <h2
          id="section-d-heading"
          className="text-2xl font-bold text-gray-900"
        >
          Section D: Consent
        </h2>
      </div>
      <div className="bg-gradient-to-r from-primary-50 to-primary-100 p-6 rounded-lg border-2 border-primary-200">
        <div className="flex items-start">
          <div className="flex items-center h-6">
            <input
              id="consent"
              type="checkbox"
              {...register('consent.agreed')}
              className="h-5 w-5 text-primary-600 focus:ring-primary-500 border-gray-300 rounded cursor-pointer"
              aria-invalid={errors.consent?.agreed ? 'true' : 'false'}
              aria-describedby={
                errors.consent?.agreed ? 'consent-error' : 'consent-description'
              }
            />
          </div>
          <div className="ml-4 text-sm">
            <label
              htmlFor="consent"
              className="font-semibold text-gray-800 cursor-pointer block"
            >
              I consent to the use of my responses for product/service quality
              and customer experience improvements. <span className="text-red-500">*</span>
            </label>
            <p
              id="consent-description"
              className="text-gray-600 mt-2 leading-relaxed"
            >
              By checking this box, you agree that your feedback may be used to
              improve our products and services. Your responses will be kept
              confidential and used only for internal analysis.
            </p>
            {errors.consent?.agreed && (
              <p
                id="consent-error"
                className="mt-2 text-sm text-red-600"
                role="alert"
              >
                {errors.consent.agreed.message}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsentSection;

